<template>
  <div class="page subsystem-stats">
    <a-row type="flex" :gutter="10" class="header">
      <a-col flex="10">
        <h1>Статистика подсистем</h1>
      </a-col>

<!--      <a-col flex="1">-->
<!--        <a-button icon="download" size="large" class="ant-btn-download"> Выгрузить </a-button>-->
<!--      </a-col>-->
    </a-row>

    <tabs v-model="activeTab" :tabs="tabTitles">
      <div :key="tabs.TAB_DATA_RECEIVING" class="tabs__pane">
        <data-receiving-stat v-if="activeTab === tabs.TAB_DATA_RECEIVING" />
      </div>

      <div :key="tabs.TAB_IDENTIFICATION" class="tabs__pane">
        <identification-stat v-if="activeTab === tabs.TAB_IDENTIFICATION" />
      </div>

      <div :key="tabs.TAB_MACHINE_LEARNING" class="tabs__pane">
        <machine-learning-stat v-if="activeTab === tabs.TAB_MACHINE_LEARNING" />
      </div>

      <div :key="tabs.TAB_MATH_PROCESSING" class="tabs__pane">
        <math-processing-stat  v-if="activeTab === tabs.TAB_MATH_PROCESSING" />
      </div>
    </tabs>
  </div>
</template>

<script>
import Tabs from '@/components/base/Tabs.vue';
import DataReceivingStat from '@/components/subsystem-stats/DataReceivingStat';
import IdentificationStat from '@/components/subsystem-stats/IdentificationStat';
import MachineLearningStat from '@/components/subsystem-stats/MachineLearningStat';
import MathProcessingStat from '@/components/subsystem-stats/MathProcessingStat';

const tabs = Object.freeze({
  TAB_DATA_RECEIVING: 'Прием данных',
  TAB_IDENTIFICATION: 'Идентификация',
  TAB_MACHINE_LEARNING: 'Машинное обучение',
  TAB_MATH_PROCESSING: 'Математическая обработка',
});

export default {
  name: 'SubsystemStats',
  components: {
    MachineLearningStat,
    IdentificationStat,
    Tabs,
    DataReceivingStat,
    MathProcessingStat
  },

  data: () => ({
    tabs,
    activeTab: tabs.TAB_DATA_RECEIVING,
  }),

  computed: {
    tabTitles() {
      return [tabs.TAB_DATA_RECEIVING, tabs.TAB_IDENTIFICATION, tabs.TAB_MACHINE_LEARNING, tabs.TAB_MATH_PROCESSING];
    },
  },
};
</script>

<style lang="scss">
.subsystem-stats {
  .tabs {
    &__switch-list {
      background: #cdd7e4;
    }

    &__pane {
      padding-top: 20px;
    }
  }

  .ant-table-wrapper {
    overflow-x: auto;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 6px;
  }

  .filters {
    margin-bottom: 10px;

    .tabs {
      &__switch-list {
        width: 100%;
        height: 40px;
        line-height: 30px;
        background: #fff !important;
        display: flex;
      }

      &__switch {
        flex: 1 1 auto;
        text-align: center;
        white-space: nowrap;

        &--active {
          background: #cdd7e4;
        }
      }
    }
  }
}
</style>
